export default function UxMotion() {
  return (
    <div className='space-y-10'>
      <div className='space-y-2'>
        <p className='text-xs text-gray-500 opacity-50'>인터렉션</p>
        <h2 className='text-2xl pb-4 text-gray-900 dark:text-gray-200'>
          <span className='font-title'>모션 인터렉션</span>
        </h2>
        <p className='text-sm text-gray-500 opacity-75'>어떻게 적용해야 할까?</p>
      </div>
      <div className=''>
        <h2 className='subtitle'>
          <span className='font-title'>컨텍스트 파악 유도</span>
        </h2>
        <p className='text-sm text-gray-500 opacity-75'>...</p>
      </div>
      <div className=''>
        <h2 className='subtitle'>
          <span className='font-title'>행동을 유도</span>
        </h2>
        <p className='text-sm text-gray-500 opacity-75'>...</p>
      </div>
      <div className=''>
        <h2 className='subtitle'>
          <span className='font-title'>필요한 부분 강조</span>
        </h2>
        <p className='text-sm text-gray-500 opacity-75'>...</p>
      </div>
      <div className=''>
        <h2 className='subtitle'>
          <span className='font-title'>사용자 행위 피드백</span>
        </h2>
        <p className='text-sm text-gray-500 opacity-75'>...</p>
      </div>
      <div className=''>
        <h2 className='subtitle'>
          <span className='font-title'>컨셉 강화</span>
        </h2>
        <p className='text-sm text-gray-500 opacity-75'>...</p>
      </div>
      <div className=''>
        <h2 className='subtitle'>
          <span className='font-title'>시각적 즐거움</span>
        </h2>
        <p className='text-sm text-gray-500 opacity-75'>...</p>
      </div>
    </div>
  )
}
